import React, { useRef } from "react";
import SelectControl from "../SelecControl/SelectControl";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faBackspace, faPaperclip, faXmark, faDownload } from "@fortawesome/free-solid-svg-icons";

const RRDocumentoForm = ({documento,handleChange,handleDelete,setData,index,modo,setShowAdd,setNuevoEditado,setIndexToUpdate,optionsDocumentos, archivoDoc, onFileChange}) =>{

    const fileInputRef = useRef(null);

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if(file) onFileChange(index, documento.documento.value, file);
        e.target.value = '';
    };

    const handleFileRemove = () => {
        onFileChange(index, documento.documento.value, null);
    };

    const getDisplayName = () => {
        if(archivoDoc?.file) return archivoDoc.file.name;
        if(archivoDoc?.existingName) {
            const parts = archivoDoc.existingName.split('_');
            return parts.length > 1 ? parts.slice(1).join('_') : archivoDoc.existingName;
        }
        return null;
    };
    const fileName = getDisplayName();

    return <div className={`rrDocumentoFormDiv ${modo != 'Vista' ? 'sixColumns' : 'fiveColumnsVista'}`}>
        {modo != 'Vista' && <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '5%', height: '40px', marginTop: "5px", cursor: "pointer" }} className="deleteIconRR" onClick={()=>handleDelete(documento,index)}/>}
        <SelectControl placeholder={"Seleccione un tipo de documento..."} modo={modo} idSelect={"documento"} handleChengeSelect={handleChange} optionsSelect={optionsDocumentos}
        valueSeleccionada={documento.documento} propToChange="documento" tipo={'documentos'} selectSelect={handleChange} setData={setData} setIndexToUpdate={setIndexToUpdate} index={index} setNuevoEditado={setNuevoEditado} setShowAdd={setShowAdd}/>
        <input onChange={(e) => handleChange(e,index)} value={documento.textAdic} disabled={modo == 'Vista'} name="textAdic"/>
        <input onChange={(e) => handleChange(e,index)} value={documento.fecha} disabled={modo == 'Vista'} name="fecha" type="date"/>
        <input onChange={(e) => handleChange(e,index)} value={documento.alertaAnticipo} disabled={modo == 'Vista'} type="number" name="alertaAnticipo"/>
        <div className="archivoDocCell">
            {modo != 'Vista' && !fileName && <div style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                <input type="file" ref={fileInputRef} onChange={handleFileSelect} style={{display:'none'}} accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.ppt,.pptx,.txt,.rtf,.odt,.ods,.odp,.jpg,.jpeg,.png,.gif,.bmp,.webp,.svg,.tiff,.mp4,.avi,.mov,.mkv,.mp3,.wav,.zip,.rar,.7z"/>
                <div style={{ cursor:'pointer'}} onClick={() => fileInputRef.current?.click()}>
                    <label>Adjuntar archivo</label>
                    <FontAwesomeIcon icon={faPaperclip} className="attachIcon"  title="Adjuntar archivo"/>
                </div>
            </div>}
            {fileName && <div className="archivoDocInfo" style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                <span className="archivoDocName" title={fileName}>{fileName.length > 18 ? fileName.substring(0,18) + '...' : fileName}</span>
                {archivoDoc?.url && <a href={archivoDoc.url} download={fileName} target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faDownload} className="downloadFileIcon" title="Descargar archivo"/>
                </a>}
                {modo != 'Vista' && <FontAwesomeIcon icon={faXmark} className="removeFileIcon" onClick={handleFileRemove} title="Quitar archivo"/>}
            </div>}
        </div>
    </div>

}

export default RRDocumentoForm;